/**
 * Created by dushyantha on 7/13/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name crewSchedule.service:crewScheduleService
     *
     * @description
     *
     */
    angular
        .module('crewSchedule')
        .service('crewScheduleService', crewScheduleService);

    function crewScheduleService(CommonMasterData, RemoteService, CommonLogicService) {
        var vm = this;

        /**
         * Set crew display name
         */
        vm.adaptCrewList = function (crewList) {
            angular.forEach(crewList, function (crew) {
                crew.displayName = crew.firstName + ' ' + crew.lastName;
            });
            return crewList;
        };

        /**
         * Adapt actual schedule search param
         */
        vm.adaptActualScheduleSearchParam = function (searchDetails) {
            var searchParam = {};
                searchParam.pageSize = 1;
                searchParam.startPosition = 1;
                searchParam.fromDate = searchDetails.fromDate;
                searchParam.toDate = searchDetails.toDate;
                searchParam.crewType = (searchDetails.crewType && searchDetails.crewType.crewTypeCode) || '';
                searchParam.hubCode = (searchDetails.employerHub && searchDetails.employerHub.hubCode) || '';
                searchParam.category = '';
                searchParam.acModel ='';
                searchParam.group = '';
                searchParam.base = searchDetails.crewBase.airPortCode;
                if(searchDetails.crewID =='' && !!searchDetails.crewDetails){
                    searchParam.crewIds = searchDetails.crewDetails.crewId;
                }
                else{
                    searchParam.crewIds = searchDetails.crewID;
                }

            return searchParam;
        };

        /**
         * Adapt state params
         */
        vm.adaptStateParams =function(stateParams){
            var searchParam = {};
            searchParam.pageSize = 1;
            searchParam.startPosition = 1;
            searchParam.fromDate = stateParams.fromDate;
            searchParam.toDate = stateParams.toDate;
            searchParam.crewType ='';
            searchParam.category = '';
            searchParam.acModel ='';
            searchParam.group = '';
            searchParam.base = '';
            searchParam.crewIds = stateParams.crewId;
            return searchParam;
        };

        /**
         * Search crew Actual Schedule
         * @param params
         * @param showLoading
         * @param successFn
         * @param errorFn
         */
        vm.searchCrewSchedule = function (param,showLoading, successFn, errorFn) {
            RemoteService.searchCrewSchedule(param, showLoading).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        /**
         * Search crew Publish Schedule
         * @param params
         * @param successFn
         * @param errorFn
         */
        vm.searchCrewPublishSchedule = function(param,successFn,errorFn){
            RemoteService.searchCrewPublishSchedule(param,true).then(
                function(response){
                    successFn(response);
                },
                function(error){
                    errorFn(error.msg);
                }
            );
        };

        /**
         * Search Airport Exclusion
         * @param crewProfileId
         * @param successFn
         * @param errorFn
         */
        vm.loadCrewAirportsExclusion = function(crewProfileId,successFn,errorFn){
            RemoteService.loadCrewAirportsExclusion(crewProfileId).then(
                function(response){
                    if (response.success){
                        successFn(response.airportExclusions);
                    }
                },
                function(error){
                    errorFn(error.msg);
                }
            );
        };

        /**
         * Search Crew Exclusion
         * @param param:{crewProfileId}
         * @param successFn
         * @param errorFn
         */
        vm.loadCrewExclusion = function (param, successFn, errorFn) {
            RemoteService.loadCrewExclusion(param, true).then(
                function (response) {
                    successFn(response.crewExclusionCollection);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        /**
         * get crew Img Url
         * @param crewProfileId
         * @param successFn
         * @param errorFn
         */
        vm.loadCrewImageURL = function(crewProfileId,successFn,errorFn){
            RemoteService.getCrewImgDataUrl(crewProfileId)
              .then(function(response){
                if (response){
                  CommonLogicService.getDataUrlFromResponse(response)
                    .then(function(dataUrl) {
                      successFn(dataUrl);
                    })
                    .catch(function(error) {
                      errorFn(error);
                    });
                }
              },
              function(error){
                errorFn(error.msg);
              }
            );
        };

        /**
         * Add Edit notes
         * @param noteDetails
         * @param successFn
         * @param errorFn
         */
        vm.addEditNotes = function (noteDetails,successFn,errorFn){
            RemoteService.addEditNotes(noteDetails).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        /**
         * Search crew notes
         * @param param
         * @param successFn
         * @param errorFn
         */
        vm.searchCrewNote = function(param,successFn,errorFn){
            RemoteService.viewCrewNotes(param,true).then(
                function(response){
                    if (response.success) {
                        successFn(response.searchCrewScheduleNotes);
                    }
                },
                function(error){
                    errorFn(error.msg);
                }
            );
        };

        /**
         * Delete crew notes
         * @param param
         * @param successFn
         * @param errorFn
         */
        vm.deleteCrewNotes = function(param,successFn,errorFn){
            RemoteService.deleteCrewScheduleNote(param,true).then(
                function(response){
                    if (response.success) {
                        successFn(response);
                    }
                },
                function(error){
                    errorFn(error.msg);
                }
            );
        };

        /**
         * FDP Processing Schedules
         * @param param
         * @param successFn
         * @param errorFn
         */
        vm.getFdpPendingCrewSchedules = function(param, successFn, errorFn){
          RemoteService.getFdpPendingCrewSchedules(param).then(
            function(response){
              successFn(response);
            },
            function(error){
              errorFn(error.msg);
            }
          );
        };

        var getPattern = function (duty) {
            var pattern = {};
            pattern.eventType = 'PATTERN';
            pattern.events = [];
            pattern.patternId = duty.patternId;
            pattern.checkInDate = duty.checkInDate;
            pattern.checkInTime = duty.checkInTime;
            pattern.patternName = duty.patternName;
            return pattern;
        };

        var getNewPattern = function (duty) {
            var pattern = getPattern(duty);
            pattern.events.push(getBlock(duty, 'DUTY'));

            if (!!duty.restStartDate) {
                pattern.events.push(getBlock(duty, 'REST'));
                pattern.checkOutDate = duty.restEndDate;
                pattern.checkOutTime = duty.restEndTime;
            } else {
                pattern.checkOutDate = duty.checkOutDate;
                pattern.checkOutTime = duty.checkOutTime;
            }
            return pattern;
        };

        var getBlock = function (duty, type) {
            if (type == 'REST') {
                var rest = {};
                rest.type = 'REST';
                rest.checkInDate = duty.restStartDate;
                rest.checkInTime = duty.restStartTime;
                rest.checkOutDate = duty.restEndDate;
                rest.checkOutTime = duty.restEndTime;
                return rest;
            } else if (type == 'DUTY') {
                duty.type = 'DUTY';
                return duty;
            }
        };
        var addCrewInfoToBlock = function (block, crewDTO) {
            block.crewInfo = {
                crewProfileId: crewDTO.crewProfileId,
                crewId: crewDTO.crewId,
                crewTypeCode: crewDTO.crewTypeCode,
                crewTypeMasterCode : crewDTO.crewTypeMasterCode,
                firstName: crewDTO.firstName,
                lastName: crewDTO.lastName
            };
            return block;
        };

        /*Adapt roster Duty */
        vm.adaptSchedule = function(schedule,crewDTO){
            var tmpCrewInfo;
                var dto=[];
                var tmp;

                /*Adapt roster Duty */
                angular.forEach(schedule, function (duty) {
                    duty.crewInfo= crewDTO;

                    if (!!duty.patternId) {
                        tmp = _.findWhere(dto, {patternId: duty.patternId});
                        if (!!tmp) {
                            tmp.events.push(getBlock(duty, 'DUTY'));

                            if (!!duty.restStartDate) {
                                tmp.events.push(getBlock(duty, 'REST'));
                                tmp.checkOutDate = duty.restEndDate;
                                tmp.checkOutTime = duty.restEndTime;
                            } else {
                                tmp.checkOutDate = duty.checkOutDate;
                                tmp.checkOutTime = duty.checkOutTime;
                            }

                        } else {
                            dto.push(getNewPattern(duty));
                        }
                    } else {
                        dto.push(getNewPattern(duty));
                    }
                });


            return dto;
        };
        vm.adaptExpiry = function(expiryDTO,searchParam) {
            angular.forEach(expiryDTO, function (expiry) {
                expiry.isExpiry =!moment(expiry.dateOfExpiry ,"DD/MM/YYYY").isSameOrAfter(moment(searchParam.toDate,"DD/MM/YYYY"))
            });
            return expiryDTO;
        }
      vm.setIsPublished = function(value){
        vm.isPublished = value
      }

      vm.getIsPublished = function(){
        return vm.isPublished;
      }

      vm.getLimitationWarnings = function(requestParam, successFn, errorFn) {
        return RemoteService.getLimitationWarnings(requestParam).then(
          function(response) {
            if(response.success) {
              successFn(response);
            }
          },
          function(error) {
            errorFn(error.msg[0]);
          }
        );
      }

    }
}());
